<div class="dashboardContainer">
    <div class="widgetsContainer">
        @if (listingsStatusSummaryWidgetConfiguration) {
            <app-pie-chart-dashboard-widget [dashboardWidgetConfiguration]="listingsStatusSummaryWidgetConfiguration" />
        }

        <app-download-reports-dashboard-widget *appPermission="'dashboard.reports'" />

        @if (listingsNotUpdatedWidgetConfiguration) {
            <app-list-style-dashboard-widget [dashboardWidgetConfiguration]="listingsNotUpdatedWidgetConfiguration" />
        }

        <app-batch-operations-dashboard-widget *appPermission="'dashboard.batchOperations'" />
        <app-scheduled-reports-dashboard-widget *appPermission="'dashboard.reports'" />

        @let hasListingChannelComparisonEnabled = featureFlagService.featureFlags()[featureFlagEnum.LISTING_CHANNEL_COMPARISON];
        @if (hasListingChannelComparisonEnabled && hasAccessToChannelSnapshotConfigs()) {
            <app-scheduled-channel-snapshots-widget class="full-width" />
        }
    </div>
    <img
        class="iceportalLogo"
        [ngSrc]="IMAGES.LOGOS.ICEPORTAL_CONTENT_LOGO_HORIZONTAL_SVG"
        alt="IcePortal Content Logo"
        width="322"
        height="40"
        priority
    />
</div>
